module.exports = __webpack_public_path__ + "img/baseMap.b27287fb.png";